import React , { useState } from "react";
import Fade from "react-reveal/Fade";

import SavingsAccount from "../../components/CreateAccount/SavingsAccount";
import CurrentAccount from "../../components/CreateAccount/CurrentAccount";
import Loader from "../../components/loading";
import ProgressBar from "../../components/ProgressBar";

const DocsUpload = ({ navigation, isUploading, globalState }) => {
  const cusId = sessionStorage.getItem("customerid");
  const bvnData = JSON.parse(sessionStorage.getItem("res"));
  const entire = JSON.parse(sessionStorage.getItem("body"))
  const FullName = sessionStorage.getItem("fullname");
  // const [isUploading , setIsUploading] = useState(false)

 

  const init_state = {
    isUploaded: false,
    successMsg: "",
    errorMsg: "",
  };
  
  const [formData, setFormData] = useState({
    utility: init_state,
    passportPhotograpgh: init_state,
    signature: init_state,
    reference: init_state,
    // mandateCard: init_state,
    isUploading: false,
  });

  return (
    <>
      <Fade bottom>
      <ProgressBar page="docs" />
        <div
          className="container-fluid position-relative"
          style={{
            marginTop: "1rem",
            textAlign: "center",
            position: "relative",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            backgroundColor: "#ffffff",
          }}
        >
          <div 
          className="firstDiv" 
          style={{ marginTop: "1rem" }}
          
          >
            <p className="text-center">
              Fields marked with
              <span style={{ fontSize: "1.5rem", color: "red" }}>*</span>
              are very mandatory
            </p>
          </div>

          <div className="row  mt-0  mx-auto ">
            {entire?.accountType === "65" || entire?.accountType === "184"   ? (
              <>
                <SavingsAccount
                  accountName={bvnData?.FirstName}
                  lastName={bvnData?.FirstName}
                  customerId={cusId}
                  navigation={navigation}
                  bvn={bvnData?.BVN}
                  globalState={globalState}
                  entire={entire}
                  accountType={entire?.accountType}
                  FullName={FullName}
                  setFormData = {setFormData}
                  formData = {formData}
                />
              </>
            ) : (
              <>
                <CurrentAccount
                  accountName={bvnData?.FirstName}
                  lastName={bvnData?.FirstName}
                  customerId={cusId}
                  navigation={navigation}
                  bvn={bvnData?.BVN}
                  globalState={globalState}
                  entire={entire}
                  accountType={entire?.accountType}
                  FullName={FullName}
                  formData = {formData}
                  setFormData = {setFormData}

                />
              </>
            )}
          </div>
        </div>
      </Fade>
      {/* {isUploading ? (
        <Loader text="Waiting for upload" bgColor="rgba(0,0,0,0.12)" />
      ) : null} */}

       {formData.isUploading ? (
        <Loader text="Waiting for upload" bgColor="rgba(0,0,0,0.12)" />
      ) : null}
    </>
  );
};

export default DocsUpload;
